import { Check } from "lucide-react";


const ProgressSteps= ({ currentStep, totalSteps }) => {
  return (
    <div className="flex items-center mb-8">
      <div className="flex-1">
        <div className="relative pb-12">
          <div className="h-1 bg-[#2c3440] w-full rounded"></div>
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div 
              key={index}
              className={`absolute -top-2 ${index === 0 ? 'left-0' : index === totalSteps - 1 ? 'right-0' : `left-1/${totalSteps - 1}`} 
              w-6 h-6 rounded-full ${currentStep > index ? 'bg-[#2c3440]' : 'bg-gray-300'} 
              flex items-center justify-center ${currentStep > index ? 'text-white' : 'text-gray-600'} text-sm`}
            >
              {currentStep > index + 1 ? <Check className="h-3 w-3" /> : index + 1}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressSteps;
